import {
  alpha,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { NavLink, To, useMatch, useResolvedPath } from 'react-router-dom';
import { useSidebarExpanded } from '../sidebar.context';
import { listItemStyle } from './sidebar-link.styles';
import { SidebarRouteConfig } from 'pages/main-routes';

export type SidebarLinkProps = { to: To; onClose: () => null } & Omit<
  SidebarRouteConfig,
  'component'
>;

const SidebarLink = ({
  title = () => null,
  icon,
  to,
  onClose,
}: SidebarLinkProps) => {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: `${resolved.pathname}/*`, end: true });
  const expanded = useSidebarExpanded();

  const titleText = title();

  return (
    <Tooltip title={!expanded ? titleText : ''} placement="right">
      <ListItemButton
        sx={{
          ...listItemStyle,
          flexGrow: 0,
          justifyContent: expanded ? 'initial' : 'center',
        }}
        component={NavLink}
        to={to}
        selected={!!match}
        onClick={onClose}
        data-testid="SidebarLink.ListItemButton"
      >
        {icon ? (
          <ListItemIcon
            sx={theme => ({
              color: alpha(theme.palette.common.white, 0.82),
              minWidth: 0,
              justifyContent: 'center',
              marginRight: expanded ? 1 : 0,
            })}
          >
            {icon}
          </ListItemIcon>
        ) : (
          <ListItemIcon sx={{ minWidth: 0, marginRight: expanded ? 2 : 0 }} />
        )}
        {expanded && <ListItemText primary={titleText} />}
      </ListItemButton>
    </Tooltip>
  );
};

export default SidebarLink;
